import { Routes,Route } from 'react-router-dom';
import './App.css';
// import All from './Components/All';
import Daily_blog from './Components/Pages/Daily_blog';
import Editpage from './Components/Pages/Editpage';
import First_page from "./Components/Pages/First_page";
import MyPost from "./Components/Pages/MyPost";
import Tech from "./Components/Pages/Tech";
function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<First_page />} />
        {/* <Route path="/all" element={<All />} /> */}
        <Route path="/dailyblog" element={<Daily_blog />} />
        <Route path="/tech" element={<Tech />} />
        <Route path="/mypost" element={<MyPost />} />
        <Route path='/edit/:id' element={<Editpage />} />
      </Routes>
    </div>
  );
}

export default App;
